













































































import { defineComponent, ref, onMounted, onUnmounted } from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import { useFlashSale } from "~/composables";

export default defineComponent({
  name: "FlashSale",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    CategoryProductDeal: () =>
      import("~/components/homePage/flashSale/CategoryProductDeal.vue"),
    ProductLoadItem,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  setup() {
    const { load: loadFlashSale, loading } = useFlashSale();
    const getFlashSale = ref<any[]>([]);
    const days = ref(null);
    const hours = ref(null);
    const minutes = ref(null);
    const seconds = ref(null);

    const loadSale = ref(false);
    onMounted(async () => {
      const loadSale = ref(false);
      const result = await loadFlashSale();
      getFlashSale.value =
        result && result.length > 0 ? changeDataFlashSale(result) : [];
      if (getFlashSale.value && getFlashSale.value.length > 0) {
        countDownTime();
      }
      loadSale.value = true;
    });

    const getTimeLeft = (until: number) => {
      return {
        seconds: Math.floor(until % 60),
        minutes: Math.floor(until / 60) % 60,
        hours: Math.floor(until / (60 * 60)) % 24,
        days: Math.floor(until / (60 * 60 * 24)),
      };
    };

    const interval = ref(null);
    const countDownTime = () => {
      const time =
        getFlashSale.value?.length > 0
          ? getFlashSale.value[0].deals[0]?.date_to
          : 0;
      if (time != 0) {
        const result =
          new Date(time?.replace(/-/g, "/")).getTime() - new Date().getTime();
        let times = result / 1000;
        interval.value = setInterval(() => {
          times = times - 1;
          const {
            days: d,
            hours: h,
            minutes: m,
            seconds: s,
          } = getTimeLeft(times);
          days.value = d;
          hours.value = h > 9 ? h.toString() : `0${h}`;
          minutes.value = m > 9 ? m.toString() : `0${m}`;
          seconds.value = s > 9 ? s.toString() : `0${s}`;
        }, 1000);
      } else {
        if (interval.value) {
          clearInterval(interval.value);
        }
      }
    };

    onUnmounted(() => {
      if (interval.value) {
        clearInterval(interval.value);
      }
    });

    const changeDataFlashSale = (data) => {
      if (data && data.length > 0) {
        let flashSaleOff = [];
        let flashSaleHot = [];
        data.map((item) => {
          if (item.deal_qty > item.sale_qty && item.sale_qty > 0) {
            flashSaleHot.push(item);
          } else {
            flashSaleOff.push(item);
          }
        });

        return [...checkProductSale(flashSaleHot), ...flashSaleOff];
      }
    };

    const checkProductSale = (dataProduct) => {
      return dataProduct.sort(
        (a, b) =>
          (a.deal_qty - a.sale_qty) / a.deal_qty -
          (b.deal_qty - b.sale_qty) / b.deal_qty
      );
    };

    const OptionItemProduct = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 4,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      scrollbar: { draggable: true },
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 4,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 4,
        },
        1024: {
          slidesPerView: 4.4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
        1440: {
          slidesPerView: 5.4,
          slidesPerGroup: 5,
          spaceBetween: 20,
        },
      },
    };

    return {
      getFlashSale,
      days,
      hours,
      minutes,
      seconds,
      loading,
      OptionItemProduct,
      loadSale,
    };
  },
});
